import React from 'react';

const Bluetooth = () => {
    return (
        <div>
            <h2>Bluetooth</h2>
        </div>
    );
};

export default Bluetooth;